import { http, HttpResponse } from "msw";

export const productHandlersStatic = [
  http.get("*/api/agent/deployments/:id/products", () =>
    HttpResponse.json(
      {
        products: {
          ai: {
            enabled: true,
          },
          sast: {
            enabled: true,

            human_autofix_enabled: true,
            ai_autofix: {
              enabled: true,
              min_confidence: "0.5",
            },
            ai_autotriage: {
              enabled: true,

              send_to_scm_comments: true,
              send_to_slack: true,
            },
          },
          sca: {
            enabled: true,
            blockPrEnabled: true,
          },
          secrets: {
            enabled: true,
            global_validation_state_policy: {
              error: "block",
              invalid: "comment",
            },
          },
        },
      },
      { status: 200 }
    )
  ),
];
